import { RemoveConfirmationAlert } from '@components/dialogs/removeConfirmationAlert';
import { useRemoveNote } from '@services/notes/remove';
import { useTranslation } from 'react-i18next';
import { RemoveNoteDialogProps } from './types';

export const RemoveNoteDialog = ({
  children,
  note: { id, jobId, typeId, referableType },
  usage,
}: RemoveNoteDialogProps) => {
  const { t } = useTranslation('app');

  const remove = useRemoveNote({});

  return (
    <RemoveConfirmationAlert
      title={t('deleteDialog.title', {
        item: t(`deleteDialog.item.${usage === 'office' ? 'comment' : 'note'}`),
        name: '',
      })}
      description={t('deleteDialog.description', {
        item: t(`deleteDialog.item.${usage === 'office' ? 'comment' : 'note'}`),
      })}
      onConfirm={() =>
        remove.mutate({
          id,
          jobId,
          referableId: referableType === 'Job' ? jobId : typeId,
          referableType,
        })
      }
      locked={false}>
      {children}
    </RemoveConfirmationAlert>
  );
};
